import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function VisionSection() {
  return <Section background="ivory" className="text-center py-32 md:py-48" data-id="element-341">
      <div className="max-w-4xl mx-auto" data-id="element-342">
        <FadeIn data-id="element-343">
          <div className="w-16 h-[1px] bg-purple-400 mx-auto mb-12" data-id="element-344"></div>
          <h2 className="text-4xl md:text-6xl font-serif text-charcoal leading-tight mb-8" data-id="element-345">
            Rebuilding Wellness <br data-id="element-346" />
            <span className="italic text-charcoal/60" data-id="element-347">Around Women</span>
          </h2>
          <p className="text-xl md:text-2xl text-charcoal/80 font-light leading-relaxed mb-12" data-id="element-348">
            Fem Entity is not just a platform — it is infrastructure for a new
            model of care. Investing in women's health creates a 3x economic
            return, while unlocking healthier communities, stronger workforces,
            and more equitable systems.
          </p>
          <div className="w-16 h-[1px] bg-purple-400 mx-auto" data-id="element-349"></div>
        </FadeIn>
      </div>
    </Section>;
}